import React from 'react';
import ThemePreview from '../components/ThemePreview';
import ThemeStyleGuide from '../components/ThemeStyleGuide';
import { FiSettings } from 'react-icons/fi';

/**
 * ThemeSettings page
 * 
 * A dedicated page for users to preview and customize theme settings.
 */
const ThemeSettings: React.FC = () => {
  return (
    <div className="min-h-screen p-6">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <FiSettings className="h-6 w-6 text-theme" />
            <h1 className="text-2xl font-bold dark:text-white text-gray-900">Theme Settings</h1>
          </div>
          <p className="dark:text-gray-300 text-gray-700">
            Customize your experience by choosing your preferred theme color.
            The selected accent color will be applied throughout the application.
          </p>
        </div>

        {/* Theme Preview Component */}
        <ThemePreview />
        
        {/* Theme Style Guide */}
        <ThemeStyleGuide />
        
        {/* Additional Settings (can be expanded in the future) */}
        <div className="mt-8 p-6 dark:bg-dark-surface bg-white rounded-lg shadow-lg border dark:border-gray-700 border-gray-200">
          <h2 className="text-xl font-bold dark:text-white text-gray-900 mb-4">Additional Settings</h2>
          
          <div className="space-y-4">
            <p className="dark:text-gray-300 text-gray-700">
              Theme settings are automatically saved to your browser's local storage. 
              Your preferences will persist between sessions.
            </p>
            
            {/* Placeholder for future settings */}
            <div className="p-4 border dark:border-gray-700 border-gray-200 rounded-lg dark:bg-dark-card bg-gray-50">
              <p className="text-sm dark:text-gray-400 text-gray-500">
                Additional theming options will be available in future updates.
              </p>
            </div>
          </div>
        </div>
        
        {/* Back to Profile Button */}
        <div className="mt-8 flex justify-center">
          <button
            onClick={() => window.history.back()}
            className="
              px-6 py-3
              rounded-lg
              dark:bg-dark-card
              bg-white
              border-2
              dark:border-theme
              border-theme
              dark:text-theme
              text-theme
              font-semibold
              hover:shadow-theme
              focus:outline-none
              focus:ring-2
              focus:ring-theme
              transition-all
              flex items-center gap-2
            "
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Profile
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThemeSettings;
